<!-- eslint-disable vue/no-unused-vars -->
<template>
    <div>
        <b-navbar toggleable="lg" type="dark" variant="primary" fixed="top">
            <b-navbar-brand href="#" @click="goback()">
                <b-icon icon="arrow-left"></b-icon> ບັນທືກບັນຊີທົ່ວໄປ
            </b-navbar-brand>
            <b-navbar-nav class="ml-auto">
      

                <b-nav-item>
                    <b-button-group>
                        <b-button variant="success" type="submit" @click.prevent="onPosting"   >
                            <b-icon icon="cloud-check-fill" aria-hidden="true" variant="light"></b-icon> ບັນທຶກການລົງບັນຊີ
                        </b-button>
                        <b-button variant="secondary" :disabled="gltrans.doc_no==''"   @click.prevent="onPreview"    >
                            <b-icon icon="printer" aria-hidden="true"   variant="light"></b-icon> ພີມບັດຜ່ານບັນຊີ
                        </b-button>
                        <b-button variant="info" @click="onListItems">
                            <b-icon icon="list" aria-hidden="true" variant="light"></b-icon> ລາຍການ
                        </b-button>

                        <!-- <b-button variant="danger" @click="goback()">
                            <b-icon icon="x-lg" aria-hidden="true" variant="light"></b-icon> ປິດ
                        </b-button> -->
                    </b-button-group>


                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>


        <b-form id="gltrans" name="gltrans" @submit="onPosting" ref="frm">

            <b-row class="content">
                <b-col>


                    <b-card>
                        <b-row>
                            <b-col>
                                <b-form-group label-cols="12" label-cols-lg="2" label="ໂຄງການ:">
                                    {{ user.proj_name }}
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>

                                <b-form-group label-cols="12" label-cols-lg="4" label="ເນື້ອໃນ:">
                                    <b-form-input v-model="gltrans.description" required trim></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label-cols="12" label-cols-lg="4" label="ລູກຄ້າ:">
<!-- 
                                    <b-input-group>

                                        <b-form-input v-model="gltrans.customer_name"></b-form-input>
                                        <b-input-group-append>

                                            <b-button variant="outline-success">...</b-button>

                                        </b-input-group-append>
                                    </b-input-group> -->

                                    <b-form-select v-model="gltrans.cust_code" :options="customers" required trim>
                                    </b-form-select>


                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group label="ບັດຜ່ານບັນຊີ:" label-cols="12" label-cols-lg="4">
                                    <b-form-select v-model="gltrans.trans_type_code" :options="glbook" required trim>
                                    </b-form-select>
                                </b-form-group>

                            </b-col>
                            <b-col>
                                <b-form-group label="ເງິສົດ/ເງິນໂອນ:" label-cols="12" label-cols-lg="4">
                                    <b-form-select v-model="gltrans.payment_type_id" :options="payment_types" required
                                        trim>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group label-cols="12" label-cols-lg="4" label="ເລກທີ່ເອກະສານອ້າງອີງ:">
                                    <b-form-input v-model="gltrans.ref_doc_no"></b-form-input>
                                </b-form-group>


                            </b-col>
                            <b-col>
                                <b-form-group label-cols="12" label-cols-lg="4" label="ແຫຼ່ງທືນ:">
                                    <b-form-select v-model="gltrans.funding_code" :options="source_fund" required trim>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group label-cols="12" label-cols-lg="4" label="ກົມ:">
                                    <b-form-select v-model="gltrans.dep_code" :options="dep" required trim>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label-cols="12" label-cols-lg="4" label="ກູ້ຢືມ/ຊ່ວຍເຫຼືອລ້າ:">
                                    <b-form-select v-model="gltrans.loan_type_id" :options="loan_type" required trim>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                       


                    </b-card>
                </b-col>

                <b-col cols="12" md="4">

                    <b-card>
                        <b-form-group label-cols="12" label-cols-lg="3" label="ບິນເລກທີ່">
                            <b-form-input readonly v-model="gltrans.doc_no"></b-form-input>
                        </b-form-group>


                        <b-form-group label-cols="12" label-cols-lg="3" label="ວັນທີ">
                            <b-form-datepicker v-model="gltrans.doc_date" id="datepicker-placeholder"
                                placeholder="ເລືອກບັນທີ" locale="lao" required trim>
                            </b-form-datepicker>
                        </b-form-group>

                        <!-- <b-form-group label-cols="12" label-cols-lg="3" label="ເລກທີ່ໃບອະນຸມັດ">
                            <b-form-input v-model="gltrans.ref_doc_no2"></b-form-input>
                        </b-form-group> -->

                        <b-form-group label-cols="12" label-cols-lg="3" label="ອັດຕາແລກປ່ຽນ">
                            <b-input-group>
                            <b-form-select v-model="gltrans.currency_code" :options="currencys" required trim>
                                    </b-form-select>
                            <b-form-input v-model="gltrans.rate"></b-form-input>
                            </b-input-group>
                        </b-form-group>

                        <b-form-group label-cols="12" label-cols-lg="3" label="ຜູ້ບັນທຶກ">
                            <b-form-input readonly v-model="user.username"></b-form-input>
                        </b-form-group>

                    </b-card>



                </b-col>
            </b-row>

           

        </b-form>


        <b-card>
            <b-row>
                <b-col cols="2" md="2">
                    <b-form-group label="ລາຍການກິດຈະກຳ">
                        <b-input-group>
                            <b-form-input v-model="fld.item_id" trim> </b-form-input>
                            <b-input-group-append>
                                <b-button size="sm" text="Button" variant="success">
                                    <b-icon icon="search" v-b-modal.modal-items></b-icon>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                        
                    </b-form-group>
                </b-col>
                <b-col cols="2" md="2">
                    <b-form-group label="ເລກບັນຊີ(ໜີ້)">
                        <b-input-group>
                            <b-form-input v-model="fld.account_code_dr" v-mask="'########.##.########'" placeholder="________.__.________"
                            @blur="$refs.amt_dr.$el.focus()"  :disabled="fld.account_code_cr!=''"    trim></b-form-input>
                            <b-input-group-append>
                                <b-button size="sm" text="Button" variant="danger" v-b-modal.modal-acc>
                                    <b-icon icon="search"></b-icon>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="2" md="2">

                    <b-form-group label="ເລກບັນຊີ(ມີ)">
                        <b-input-group>
                            <b-form-input v-model="fld.account_code_cr" v-mask="'########.##.########'" placeholder="________.__.________"
                             @blur="$refs.amt_cr.$el.focus()"  :disabled="fld.account_code_dr!=''"    trim></b-form-input>
                            <b-input-group-append>
                                <b-button size="sm" text="Button" variant="success">
                                    <b-icon icon="search" v-b-modal.modal-accdr></b-icon>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>


                </b-col>
                
                 
                <b-col cols="2" class="text-center">
                    

                    <b-form-group label="ໜີ້">
                         <!-- <vue-numeric ref="amt_dr" currency="" class="p-1 text-right" separator="," v-model="fld.debit">
                        </vue-numeric>  -->
                        <!-- <number ref="amt_dr"  v-model="fld.debit" class="p-1 text-right" ></number> -->

                        <nice-numeric-input v-model="fld.debit" ref="amt_dr" name="debit"  :disabled="fld.account_code_cr!=''"  noControls   label="" /> 
                    </b-form-group>
                </b-col>
                <b-col cols="2" class="text-center">
                    <b-form-group label="ມີ">

                         <!-- <vue-numeric ref="amt_cr" currency="" class="p-1 text-right" separator="," v-model="fld.credit">
                        </vue-numeric>  -->
                        <!-- <number ref="amt_cr"  v-model="fld.credit" class="p-1 text-right" ></number> -->
                        <nice-numeric-input v-model="fld.credit" ref="amt_cr" name="credit" noControls    :disabled="fld.account_code_dr!=''"  label=""/> 


                    </b-form-group>
                </b-col>
                <b-col cols="2" md="2">
                    <b-form-group label="...">
                        <b-button @click="onAdditem" variant="primary" >ເພິ່ມລາຍການ</b-button>
                    </b-form-group>
                    
                </b-col>

            </b-row>
            <b-row>
                <b-col md="4">   {{ fld.description }}  </b-col>
                <b-col>  {{ item_desc }}   </b-col>
            </b-row>
        </b-card>

        <b-table head-variant="light" hover :fields="fields" :items="rows" class="border  mt-2" foot-clone>
<template #cell(debit)="{ item }">
    <span v-if="!item.editing">
                            {{ item.debit | format }}
                        </span>
    
    <vue-numeric v-else v-model="item.temp['debit']" @keydown.enter.exact="doSave(item)" class="text-right">
    </vue-numeric>
</template>

<template #cell(credit)="{ item }">
    <span v-if="!item.editing">
                            {{ item.credit | format }}
                        </span>
    
    <vue-numeric v-else v-model="item.temp['credit']" @keydown.enter.exact="doSave(item)" class="text-right"></vue-numeric>
</template>

<template #cell(action)="{ item }">
    <b-link v-if="!item.editing" @click="doEdit(item)">
        <b-icon icon="pencil"></b-icon>
    </b-link>
    <b-link v-if="!item.editing" @click="onRemoveItem(item.account_code)">
        <b-icon icon="trash" variant="danger"></b-icon>
    </b-link>
    <b-button-group>
        <b-btn v-if="item.editing" @click="doSave(item)" variant="success">
            <b-icon icon="check2-circle"></b-icon>
        </b-btn>
        <b-btn v-if="item.editing" @click="doCancel(item)" variant="danger">
            <b-icon icon="x-circle-fill"></b-icon>
        </b-btn>
    </b-button-group>
</template>

<template #foot(account_code_dr)="data">
    <span class="text-danger"></span>
</template>

<template #foot(account_code_cr)="data">
    <span class="text-danger"></span>
</template>

<template #foot(item_id)="data">
    <span class="text-danger">ລວມ:</span>
</template>

<template #foot(description)="data">
    <span class="text-danger"></span>
</template>
            // eslint-disable-next-line vue/no-unused-vars
<template #foot(debit)="data">
    <span class="text-danger">{{ drTotal }}</span>
</template>
            // eslint-disable-next-line vue/no-unused-vars
<template #foot(credit)="data">
    <span class="text-success">{{ crTotal }}</span>
</template>

<template #foot(local_debit)="data">
    <span class="text-danger">{{ format( parseFloat( unformat( drTotal))* gltrans.rate) }}</span>
</template>
            // eslint-disable-next-line vue/no-unused-vars
<template #foot(local_credit)="data">
    <span class="text-success">{{ format( parseFloat( unformat(crTotal))* gltrans.rate)  }}</span>
</template>
        </b-table>

        <b-overlay>
            <b-modal ref="accdr-modal" id="modal-acc" title="ຄົ້ນຫາເລກບັນຊີ...." hide-footer size="lg"
                header-bg-variant="primary" header-text-variant="white">
                <b-form-group label-cols="4" label-cols-lg="3" label="ຄົ້ນຫາ:">
                    <b-form-input v-model="txtfind" @input="doFindAcc"></b-form-input>
                </b-form-group>
                <b-table hover :fields="acc_flds" :items="accounts" @row-dblclicked="RowBblclickAccDr"></b-table>
            </b-modal>

            <b-modal ref="acccr-modal" id="modal-accdr" title="ຄົ້ນຫາເລກບັນຊີ...." hide-footer size="lg"
                header-bg-variant="primary" header-text-variant="white">
                <b-form-group label-cols="4" label-cols-lg="3" label="ຄົ້ນຫາ:">
                    <b-form-input v-model="txtfind" @input="doFindAcc"></b-form-input>
                </b-form-group>
                <b-table hover :fields="acc_flds" :items="accounts" @row-dblclicked="RowBblclickAccCr"></b-table>
            </b-modal>
        </b-overlay>

        <b-modal ref="modal-items"    scrollable id="modal-items" title="ລາຍການກິດຈະກຳ...." hide-footer size="xl"
                header-bg-variant="primary" header-text-variant="white">
                <!-- <b-form-group label-cols="4" label-cols-lg="3" label="ຄົ້ນຫາ:">
                    <b-form-input v-model="txtfind" @input="doFindItems"></b-form-input>
                </b-form-group> -->
                <b-table hover id="plan_items" :items="plan_items" :fields="plan_flds" @row-dblclicked="RowBblclickitem"
             
      small     ></b-table>
                <!-- <b-pagination
      v-model="currentPage"
      :total-rows="rows1"
      :per-page="perPage"
      aria-controls="plan_items"
    ></b-pagination> -->
            </b-modal>
    </div>
</template>

<script>
import axios from "axios";
import Select2 from 'v-select2-component';

export default {
    components: Select2,
    created() {
        let login = localStorage.getItem("Login");
        this.user = JSON.parse(login);
        this.gltrans.proj_code=this.user.proj_code
        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/transaction_type/trans_type_desc/trans_type_code",
                {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.glbook = response.data;
                //    console.log(  JSON.parse(response.data))
            })

        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItemsCondition/departments/dep_name/dep_code/branch_id/" + this.user.branch_id,
                {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.dep = response.data;
                //    console.log(  JSON.parse(response.data))
            })

        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/funding_source/funding_desc/funding_code",{
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.source_fund = response.data;
                //    console.log(  JSON.parse(response.data))
            })

        //payment_types
        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/payment_types/payment_type_desc/payment_type_id",{
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.payment_types = response.data;
                //    console.log(  JSON.parse(response.data))
            })

        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/customers/cust_name/cust_code",
                {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.customers = response.data;
                //    console.log(  JSON.parse(response.data))
            })

        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/currency/currency_name/currency_code",{
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.currencys = response.data;
                //    console.log(  JSON.parse(response.data))
            })

        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/plane_item_post/item_desc_eng/item_id",{
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.plan_items = response.data;
                //    console.log(  JSON.parse(response.data))
            })

            axios
            .get(
                this.$store.getters.getBaseUrl +
                "/getItems/loan_type/loan_type_desc_lao/loan_type_id",{
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.loan_type = response.data;
                //    console.log(  JSON.parse(response.data))
            })
            //loan_type


    },

    data() {
        return {
            perPage: 10,
            currentPage: 1,
            txtfind: "",
            totaldr: 0,
            totalcr: 0,
            source_fund: [],
            dep: [],
            glbook: [],
            accounts: [],
            payment_types: [],
            customers: [],
            currencys: [],
            plan_flds: [{ label: 'ລະຫັດ', key: 'value' }, { label: 'ກິດຈະກຳ', key: 'text' }],
            item_desc: '',
            plan_items: [],
            loan_type:[],
            gltrans: {
                "doc_no": this.$route.params.val,
                "doc_date": new Date(),
                "description": "",
                "ref_doc_no": "",
                "ref_doc_date": null,
                "amount": 0,
                "local_amount": 0,
                "f_currency_code": "00",
                "rate": 1,
                "status": "Wait",
                "create_date": "",
                "create_by": "",
                "posting_date": "",
                "posting_by": "",
                "islock": "N",
                "proj_code": "",
                "book_code": "03",
                "rate_id": "",
                "currency_code": "00",
                "branch_id": "",
                "fdelete": "N",
                "delete_by": null,
                "delete_date": null,
                "trans_type_code": "",
                "total_debit": 0.00,
                "total_credit": 0.00,
                "detail": "",
                "cheque_no": "",
                "bank_code": "",
                "bank_account_no": "",
                "sector_code": null,
                "cs": 0.00,
                "cq": 0.00,
                "tr": 0.00,
                "customer_name": "",
                "cust_code": "NONE",
                "ref_doc_no2": "",
                "funding_code": "",
                "payment_type_id": "",
                "dep_code": "" ,
                "tx_type_code":"6",
                "loan_type_id":1,
                "items":[]

            },
            fld: {
                "code": "",
                "doc_no": "",
                "line_number": 1,
                "account_code": "",
                "account_code_dr": "",
                "account_code_cr": "",
                "debit": 0.00,
                "credit": 0.00,
                "currency_code": "00",
                "local_debit": 0,
                "local_credit": 0.00,
                "description": "",
                "remark": "",
                "rate": 1,
                "item_id": ""
            },
            fields: [
                { label: 'ລະຫັດກິດຈະກຳ', key: 'item_id', thClass: "text-nowrap ", tdClass: "text-nowrap " },
                { label: 'ເລກບັນຊີ(ໜີ້)', key: 'account_code_dr', thClass: "col-md-2", tdClass: "col-md-2" },
                { label: 'ເລກບັນຊີ(ມີ)', key: 'account_code_cr', thClass: "col-md-2", tdClass: "col-md-2" },
               
                { label: 'ເນື້ອໃນ', key: 'description', thClass: "col-md-1  text-nowrap ", tdClass: "col-md-2 text-nowrap", },
                { label: 'ໜີ້', key: 'debit', thClass: "col-md-1  text-right ", tdClass: "col-md-2 text-right", formatter: "format" },
                { label: 'ມີ', key: 'credit', thClass: "col-md-1  text-right", tdClass: "col-md-2  text-right", formatter: "format" },
                { label: 'ໜີ້(ກີບ)', key: 'local_debit', thClass: "col-md-2  text-right", tdClass: "col-md-2 text-right", formatter: "format" },
                { label: 'ມີ(ກີບ)', key: 'local_credit', thClass: "col-md-2  text-right", tdClass: "col-md-2  text-right", formatter: "format" },
                { label: '...', key: 'action', thClass: "  text-right", tdClass: " text-right" },
            ],
            items: [],
            user: [],
            "rows": [],
            acc_flds: [{ label: 'ເລກບັນຊີ', key: 'account_code' }, { label: 'ຊື່ບັນຊີ', key: 'account_name1' }],
        }

    },
    methods: {
        goback() {
            //this.$router.go(-1);
            this.$router.back()
        },
        format(number) {
            let amt = new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(number)
            return amt
        },
        unformat(val) {
            var group = new Intl.NumberFormat('en-US').format(1111).replace(/1/g, '');
            var decimal = new Intl.NumberFormat('en-US').format(1.1).replace(/1/g, '');
            var reversedVal = val.replace(new RegExp('\\' + group, 'g'), '');
            reversedVal = reversedVal.replace(new RegExp('\\' + decimal, 'g'), '.');
            return Number.isNaN(reversedVal) ? 0 : reversedVal;
        },
        padTo2Digits(num) {
            return num.toString().padStart(2, '0');
        },
        doEdit(item) {

            this.$set(item, 'temp', JSON.parse(JSON.stringify(item)))
            this.$set(item, 'editing', true)
            //  this.$refs['modal-edit-item'].show()
        },
        doSave(item) {

            this.$set(item, 'editing', false)
            for (let key in item.temp) {
                // console.log(key)
                if (item[key] != item.temp[key]) {
                    item[key] = item.temp[key]
                }
            }
        },
        doCancel(item) {
            this.$set(item, 'editing', false)
            this.$delete(item, 'temp')
        },
        onAdditem() {
            //  console.log('enter')
            let account_code = ''
            if (this.fld.account_code_dr != '') {
                account_code = this.fld.account_code_dr
            } else {
                account_code = this.fld.account_code_cr
            }

            let itm = {
                "doc_no": "",
                "line_number": 1,
                "account_code": account_code,
                "account_code_dr": this.fld.account_code_dr,
                "account_code_cr": this.fld.account_code_cr,
                "debit": this.fld.debit,
                "credit": this.fld.credit,
                "currency_code": this.gltrans.currency_code,
                "local_debit": parseFloat(this.fld.debit) * parseFloat(this.gltrans.rate),
                "local_credit": parseFloat(this.fld.credit) * parseFloat(this.gltrans.rate),
                "create_by": this.user.username,
                "create_date": null,
                "description": this.fld.description,
                "remark": "",
                "rate_id": 1,
                "fdelete": "N",
                "delete_by": null,
                "delete_date": null,
                "branch_id": this.gltrans.branch_id,
                "trans_code": this.gltrans.trans_type_code,
                "item_id": this.fld.item_id
            }

            this.rows.push(itm)

            this.fld = {
                "code": "",
                "doc_no": "",
                "line_number": 1,
                "account_code": "",
                "account_code_dr": "",
                "account_code_cr": "",
                "debit": 0,
                "credit": 0,
                "currency_code": this.gltrans.currency_code,
                "local_debit": 0,
                "local_credit": 0,
                "create_by": "",
                "create_date": null,
                "description": "",
                "remark": "",
                "rate": 1,
                "fdelete": "N",
                "delete_by": null,
                "delete_date": null,
                "branch_id": "",
                "trans_code": "",
                "item_id": ""
            }


        },
        onRemoveItem(code) {
            // this.rows.splice(index, 1)
            //   console.log(code)

            this.rows = this.rows.filter(item => item.account_code != code);
        },
        doFindAcc() {
            //   getAccounts
            axios
                .get(
                    this.$store.getters.getBaseUrl +
                    "/getAccounts/" + this.user.branch_id + "/" + this.txtfind +"?currency_code=" + this.gltrans.currency_code,{
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.accounts = response.data;
                    //    console.log(  JSON.parse(response.data))
                })
        },
        RowBblclickAccDr(item) {
            this.fld.account_code_dr = item.account_code
            this.fld.description = item.account_name
            this.fld.account_code_cr = ""

            this.$refs['accdr-modal'].hide()
            this.$refs.amt_dr.$el.focus();

        },

        RowBblclickAccCr(item) {
            this.fld.account_code_cr = item.account_code
            this.fld.description = item.account_name
            this.fld.account_code_dr = ""
            this.$refs['acccr-modal'].hide()
            //  this.$refs.amt_cr.$el.focus();
            this.$refs.amt_cr.$el.focus();
        },

        RowBblclickitem(item) {
            this.fld.item_id = item.value
            this.item_desc = item.text
            ///  this.fld.description = item.account_name
            // this.fld.account_code_dr = ""
            // this.$refs['acccr-modal'].hide()
            //  this.$refs.amt_cr.$el.focus();
            // this.$refs.amt_cr.$el.focus();
            this.$refs['modal-items'].hide()
        },

        onListItems() {
            this.$router.push('/pvlist?id=2300&desc=ລາຍການບັນທຶກບັນຊີ (ທົ່ວໄປ)')
        },
        onPosting(event) {
            event.preventDefault()
            this.gltrans.branch_id = this.user.branch_id,

                this.gltrans.create_by = this.user.username
            this.gltrans.create_date = new Date()
            let diff = this.unformat(this.crTotal) - this.unformat(this.drTotal)
            if (diff != 0) {
                this.$bvToast.toast('ການລົງບັນຊີຍັງບໍ່ດຸ່ນ. ກະລຸນາກວດຄືນ.', {
                    title: `Error.`,
                    variant: 'danger',
                    solid: true
                })
                return
            }
            this.gltrans.amount = this.unformat(this.crTotal)
            this.gltrans.items=this.rows
            let params = {
                hd: this.gltrans,
                items: this.rows
            }

            axios.post(this.$store.getters.getBaseUrl + '/posting', params,
            {
                headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
            })
                .then(res => {
                    if (res.data.code == 1) {
                        this.gltrans.doc_no = res.data.last_code
                    } else {
                        this.$bvToast.toast('ບໍ່ສາມາດບັນທຶກລາຍການີ້ ກະລຸນາກວດຄືນ.', {
                            title: `Error.`,
                            variant: 'danger',
                            solid: true
                        })
                    }

                    console.log(res)
                })
                .catch(err => {
                    this.$bvToast.toast('ບໍ່ສາມາດບັນທຶກລາຍການີ້ ກະລຸນາກວດຄືນ.', {
                        title: `Error.`,
                        variant: 'danger',
                        solid: true
                    })
                    console.error(err);
                })


        //    console.log(params)


        },
        onsubmit(event) {
            event.preventDefault()
            this.$refs.frm.submit(event)
        },
        doFindItems() {

        },
        onPreview(){
           

            
            let    rpt_param={
           script:"call  sp_voucher ('"+ this.gltrans.doc_no +"')",
           branch_id:this.user.branch_id
           }
        //   this.fld.script=`call sp_account_hist('`+this.fld.branch_id+`','`+this.fld.from_date+`','`+this.fld.to_date+`','`+this.fld.account_code+`')`
           let data = JSON.stringify(rpt_param);
           this.$router.push('/view_dna/rpt_voucher.mrt?data='+data)
        }
    },
    filters: {
        format(number) {
            let amt = new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(number)
            return amt
        },
        unformat(val) {
            var group = new Intl.NumberFormat('en-US').format(1111).replace(/1/g, '');
            var decimal = new Intl.NumberFormat('en-US').format(1.1).replace(/1/g, '');
            var reversedVal = val.replace(new RegExp('\\' + group, 'g'), '');
            reversedVal = reversedVal.replace(new RegExp('\\' + decimal, 'g'), '.');
            return Number.isNaN(reversedVal) ? 0 : reversedVal;
        },
        padTo2Digits(num) {
            return num.toString().padStart(2, '0');
        },
    },
    computed: {
        rows1() {
            return this.plan_items.length
        },
        crTotal() {

            let sum = this.rows.reduce(function(total, currentValue) {
                //  console.log(currentValue.Y)
                return total + parseFloat(currentValue.credit);
            }, 0);

            return this.format(sum);

        },
        drTotal() {

            let sum = this.rows.reduce(function(total, currentValue) {
                //  console.log(currentValue.Y)
                return total + parseFloat(currentValue.debit);
            }, 0);

            return this.format(sum);

        },
    },

}
</script>

<style scoped>
.content {
    padding-top: 10px;
}
</style>